// src/services/adminApi.js
const ADMIN_API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

export async function adminApiRequest(path, options = {}) {
  const token = localStorage.getItem("adminToken");

  const res = await fetch(`${ADMIN_API_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  // 🔥 HANDLE INVALID / EXPIRED TOKEN
  if (res.status === 401) {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser"); // if you store it
    window.location.href = "/admin/login";
    throw new Error("Unauthorized");
  }

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "API error");
  }

  return data;
}
